import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleUser,
    faGlobe,
    faHandHoldingDollar,
    faLocationDot,
    faPhoneFlip,
} from '@fortawesome/pro-regular-svg-icons';
import Box from '@mui/system/Box';
import PropTypes from 'prop-types';
import React from 'react';

import ContactType from '../../../types/ContactType';
import {
    getGoogleMapsLink,
    formatPostalCode,
} from '../../../utils/location';
import {
    withHttp,
    truncateUrl,
} from '../../../utils/url';

import styles from './ContactInformation.scss';

const ContactInformation = ({
    contactInfo,
    websiteUrl,
    donationUrl,
}) => (
    <div className={styles.container}>
        <h2 className={styles.header}>
            Contact Information
        </h2>
        <div className={styles.informationContainer}>
            <a
                className={styles.contactDetailsItem}
                href={getGoogleMapsLink(contactInfo.listingAddress1, contactInfo.listingAddress2, contactInfo.listingAddress3, contactInfo.listingCity, contactInfo.listingState, contactInfo.listingZip)}
                rel="noreferrer"
                target="_blank"
                aria-label="Organization Location"
            >
                <div>
                    <FontAwesomeIcon icon={faLocationDot} />
                </div>
                <span>
                    {contactInfo.listingAddress1}
                    {contactInfo.listingAddress2 && (
                        <>
                            <br />
                            {contactInfo.listingAddress2}
                        </>
                    )}
                    {contactInfo.listingAddress3 && (
                        <>
                            <br />
                            {contactInfo.listingAddress3}
                        </>
                    )}
                    <br />
                    {contactInfo.listingCity}
                    ,
                    {' '}
                    {contactInfo.listingState}
                    {' '}
                    {formatPostalCode(contactInfo.listingZip)}
                </span>
            </a>
            {contactInfo.contactPhone && (
                <a
                    className={styles.contactDetailsItem}
                    href={`tel:${contactInfo.contactPhone}`}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Organization Phone Number"
                >
                    <div>
                        <FontAwesomeIcon icon={faPhoneFlip} />
                    </div>
                    <span>
                        {contactInfo.contactPhone}
                    </span>
                </a>
            )}
            {/* need to update */}
            {contactInfo.contactName && (
                <div className={styles.contactDetailsItem}>
                    <div>
                        <FontAwesomeIcon icon={faCircleUser} />
                    </div>
                    <span>
                        {contactInfo.contactRole && (
                            <>
                                {contactInfo.contactRole}
                                {' '}
                            </>
                        )}
                        {contactInfo.contactName}
                    </span>
                </div>
            )}
            {websiteUrl && (
                <a
                    className={styles.contactDetailsItem}
                    href={withHttp(websiteUrl)}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Organization Website"
                >
                    <div>
                        <FontAwesomeIcon icon={faGlobe} />
                    </div>
                    <span>
                        {truncateUrl(websiteUrl, 36)}
                    </span>
                </a>
            )}
            {donationUrl && (
                <>
                    <a
                        className={styles.contactDetailsItem}
                        href={withHttp(donationUrl)}
                        rel="noreferrer"
                        target="_blank"
                    >
                        <div>
                            <FontAwesomeIcon icon={faHandHoldingDollar} />
                        </div>
                        <span>
                            Give Now
                        </span>
                    </a>
                    <Box minWidth="250px" component="section" sx={{ fontStyle: 'italic' }}>
                        This link takes you to an external donation site entered by your parish.
                    </Box>
                </>
            )}
        </div>
    </div>
);

ContactInformation.propTypes = {
    classes: PropTypes.shape({
        header: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        informationContainer: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        contactInformation: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        root: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    }),
    contactInfo: ContactType.isRequired,
    websiteUrl: PropTypes.string,
    donationUrl: PropTypes.string,
};

ContactInformation.defaultProps = {
    classes: {
        header: null,
        contactInformation: null,
        informationContainer: null,
        root: null,
    },
    donationUrl: null,
    websiteUrl: '',
};

export default ContactInformation;
